import { logger } from '@zep/core-logger';

import { useQuizListItemProvider } from '@/shared/quizList/hooks/QuizListItemContext';
import { type QuizCardMenuItem } from '@/shared/quizList/hooks/useGetQuizListItemButtons';
import { type QuizListType } from '@/shared/quizList/QuizListType';
export const useQuizCardEventTrack = () => {
  const { eventLocation, quizSet, eventAdditionalProperty } =
    useQuizListItemProvider();

  const tranEvent = (event: EventType) => {
    const eventName = eventActions[event][eventLocation];
    const additionalProperty = eventAdditionalProperty
      ? eventAdditionalProperty?.[eventLocation]
      : {};

    logger.track(eventName, {
      location: eventLocation,
      id: quizSet.id,
      ...additionalProperty,
    });
  };

  return {
    trackEnter: () => tranEvent('enter'),
    trackButtons: (type: QuizCardMenuItem['onClickEventName']) =>
      tranEvent(type),
  };
};

type LocationType = QuizListType;
type EventType =
  | 'enter'
  | 'copy'
  | 'share'
  | 'report'
  | 'update'
  | 'delete'
  | 'google_assignment'
  | 'lti_select';

type EventActions = Record<EventType, Record<LocationType, string>>;

export const eventActions: EventActions = {
  enter: {
    myQuiz: 'enter_detail_myquiz',
    public: 'enter_detail_public',
    featured: 'enter_detail_featured',
    user: 'enter_detail_user',
  },
  copy: {
    myQuiz: 'copy_quiz_myquiz',
    public: 'copy_quiz_public',
    featured: 'copy_quiz_featured',
    user: 'copy_quiz_user',
  },
  share: {
    myQuiz: 'share_myquiz',
    public: 'share_public',
    featured: 'share_featured',
    user: 'share_user',
  },
  report: {
    myQuiz: 'lms_myquiz',
    public: 'lms_public',
    featured: 'lms_featured',
    user: 'lms_user',
  },
  delete: {
    myQuiz: 'delete_myquiz',
    public: 'delete_public',
    featured: 'delete_featured',
    user: 'delete_user',
  },
  update: {
    myQuiz: 'update_myquiz',
    public: 'update_public',
    featured: 'update_featured',
    user: 'update_user',
  },
  google_assignment: {
    myQuiz: 'google_assignment_myquiz',
    public: 'google_assignment_public',
    featured: 'google_assignment_featured',
    user: 'google_assignment_user',
  },
  lti_select: {
    myQuiz: 'lti_select_myquiz',
    public: 'lti_select_public',
    featured: 'lti_select_featured',
    user: 'lti_select_user',
  },
};
